import { useState, useEffect, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CAMP_QUOTES } from '../data/camp-data';

export default function WelcomeQuote({ onComplete }) {
  const [visible, setVisible] = useState(true);

  const quote = useMemo(() => {
    return CAMP_QUOTES[Math.floor(Math.random() * CAMP_QUOTES.length)];
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onComplete, 800);
    }, 4500);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
          className="fixed inset-0 z-[60] flex items-center justify-center px-6"
          style={{ background: 'var(--mc-bg)' }}
          data-testid="welcome-quote-overlay"
          onClick={() => { setVisible(false); setTimeout(onComplete, 300); }}
        >
          {/* Ambient glow */}
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background: `radial-gradient(ellipse at 50% 50%, rgba(255, 0, 127, 0.25) 0%, rgba(157, 76, 221, 0.1) 40%, transparent 70%)`,
            }}
          />

          <div className="relative max-w-2xl text-center">
            {/* Quote mark */}
            <motion.div
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 0.3, scale: 1 }}
              transition={{ delay: 0.3, duration: 0.8 }}
              className="absolute -top-16 left-1/2 -translate-x-1/2 font-heading text-[120px] sm:text-[160px] leading-none select-none"
              style={{ color: 'var(--mc-pink)', textShadow: '0 0 40px var(--mc-pink-glow)' }}
            >
              "
            </motion.div>

            {/* Quote text */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 1 }}
              className="font-comic text-3xl sm:text-4xl lg:text-5xl leading-relaxed"
              style={{ textShadow: '0 0 30px rgba(255,255,255,0.2)', color: '#FFFFFF' }}
            >
              {quote.text}
            </motion.p>

            {/* Author */}
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.4, duration: 0.8 }}
              className="mt-6 text-sm tracking-[0.25em] uppercase font-mono"
              style={{ color: '#00F0FF', textShadow: '0 0 15px rgba(0, 240, 255, 0.4)' }}
            >
              — {quote.author}
            </motion.p>

            {/* Skip hint */}
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.3 }}
              transition={{ delay: 2.5, duration: 1 }}
              className="mt-12 text-[10px] tracking-[0.2em] uppercase text-[var(--mc-text-muted)] font-mono"
            >
              klicka för att fortsätta
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
